// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar text>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title>Edit Profile</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="blue" @click="saveUser">Save</v-btn>
      </v-toolbar>
      <v-card-text>
      <v-row wrap>
        <v-col cols="12" md="4">
          <v-text-field
            name="input"
            label="Name"
            v-model="user.name"
            required
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            name="input"
            label="Username"
            :rules="[emailRule]"
            v-model="user.username"
            required
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-bind:items="roles"
            v-model="user.roles"
            item-text="name"
            item-value="id"
            multiple
            chips
            label="User Roles"
            disabled
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            name="input"
            label="New Password"
            v-model="passwordReset1"
            required
            :rules="[passwordRule, passwordsEqual]"
            type="password"
            counter :min="passwordLength">
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            name="input"
            label="Verify New Password"
            v-model="passwordReset2"
            required
            :rules="[passwordRule, passwordsEqual]"
            type="password"
            counter :min="passwordLength">
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    </v-card>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  import {ENDPOINT} from '@/shared/constants'
  import {AXIOSAPI} from '@sdgsystems/vue-common/components/requests-common'
  import ApiRequests from '@/api/ApiRequests'
  import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'
  import Rules from '@sdgsystems/vue-common/components/rules'

  export default {
    components: {
      ErrorSnackbar
    },

    data () {
      return {
        contractors: [],
        endpoint: ENDPOINT,
        errorText: '',
        passwordLength: Rules.PASSWORDLENGTH,
        passwordReset1: '',
        passwordReset2: '',
        roles: [],
        // User needs these empty fields or the field rules don't like it.
        user: {
          password: '',
          username: '',
          securityCtx: {
            companies: [],
            sites: []
          }
        },
        sites: []
      }
    },

    created () {
      this.getUser()
      this.getRoles()
    },

    computed: {
      ...mapGetters({
        activeAccessRules: 'accessRules',
        activeUser: 'user'
      }),

      passwordsEqual: function () {
        if ((this.passwordReset1 === this.passwordReset2) || this.passwordReset2.length === 0) {
          return true
        } else {
          return 'Passwords are not the same'
        }
      }
    },

    methods: {
      getUser: function () {
        ApiRequests.getUser('me').then(r => {
          this.user = r.data
          if (!(this.user.securityCtx.sites)) {
            this.user.securityCtx.sites = []
          }
        }).catch(e => {
          this.errorText = e.response.statusText + ': ' + e.response.data
        })
      },

      getRoles: function () {
        ApiRequests.getRoles().then((response) => {
          this.roles = response.data
        })
      },

      saveUser: function () {
        if (this.user.name && (this.emailRule(this.user.username) === true)) {
          if (this.passwordReset1.length > 0) {
            if (Rules.password(this.passwordReset1) !== true || this.passwordsEqual !== true) {
              this.errorText = 'Passwords must match'
              return
            } else {
              this.user.password = this.passwordReset1
            }
          }

          AXIOSAPI.put(ENDPOINT + 'users/me', this.user).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        } else {
          this.errorText = 'Please fill out all required fields'
        }
      },

      emailRule: function (address) {
        return Rules.email(address)
      },

      passwordRule: function (password) {
        return Rules.password(password)
      },

      exit: function () {
        this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UserMe.vue